import * as Cookie from 'js-cookie';
import { forEach, get, isEqual, values } from 'lodash';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { LOCATION_CHANGED } from 'redux-little-router';

import { Action } from '../../actions';
import { ON_ACCEPT_BULK_IMAGE_REPLACEMENT } from '../../actions/banners-edit/banner-text-image';
import {
    ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    ACCEPT_MASS_ACTIONS_CALLOUTS,
    ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE,
    ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_OPEN_MASS_ACTIONS_CALLOUTS,
    ON_OPEN_MASS_ACTIONS_COUNTERS,
    ON_OPEN_MASS_ACTIONS_PIXEL,
    ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR,
    OPEN_MASS_ACTIONS_BANNERS_PRICE,
    OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR
} from '../../actions/banners-edit/banners-edit-mass-actions';
import { UPDATE_BANNERS_FOR_EDIT } from '../../actions/bannersEdit';
import { UPDATE_CAMPAIGN_DAY_BUDGET_INFO } from '../../actions/campaigns-grid';
import {
    CHANGE_BANNERS_TEXT_SUBSTITUTION_FLAG,
    CHANGE_CONSIDER_COMPETITORS_FLAG,
    CHANGE_SHOW_YANDEX_CATALOG_INFO_FLAG
} from '../../actions/campaignsEdit';
import { FREELANCER_INFO_PANEL_CLICKED } from '../../actions/clientFreelancerData';
import {
    PROCESS_SIDEBAR_CLICK,
    ProcessSidebarClick
} from '../../actions/common';
import {
    ACCEPT_REJECT_DEALS,
    OPEN_DEAL_INSPECTOR,
    UPDATE_DEALS
} from '../../actions/deals';
import { OPEN_FREELANCER_FEEDBACK_FORM } from '../../actions/freelancers/feedback-form';
import { REQUEST_COOP_BY_CUSTOMER_START } from '../../actions/freelancers/freelancer-accept-popup';
import {
    ACKNOWLEDGE_USER_STAYED_ON_CARD,
    FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT,
    FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE,
    OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT,
    SHOW_FREELANCER_CONTACTS
} from '../../actions/freelancers/freelancer-card';
import { ADD_FREELANCER_FEEDBACK_START } from '../../actions/freelancers/freelancer-feedback';
import {
    CHANGE_COLUMNS_GRID_ORDER,
    CHANGE_COLUMNS_GRID_VISIBILITY,
    FETCH_TOOLTIP_DATA,
    FIRE_GRID_SCREEN_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT,
    FIRE_SHOW_GRID_SCREEN_RECOMMENDATION_EVENT,
    OPEN_EDIT_CAMPAIGN_POPUP,
    OPEN_EDIT_GROUPS_POPUP,
    OPEN_GRID_SCREEN_RECOMMENDATIONS_POPUP,
    RENDER_ON_FINISHED,
    SUBMIT_GRID_SCREEN_RECOMMENDATION_ITEM,
    SWITCH_TO_OLD_INTERFACE,
    TOGGLE_COMPACT_VIEW,
    UPDATE_ADDITIONAL_FILTER,
    UPDATE_CALC_TYPE_FILTER,
    UPDATE_GRID_SELECTION
} from '../../actions/grid-screen';
import { OPEN_PRICES_WIZARD } from '../../actions/grid-wizards';
import { UPDATE_DATA_FOR_EDIT_GROUPS } from '../../actions/groupsEdit';
import {
    FIRE_COMMON_WALLET_CLICK,
    UPDATE_HEADER_INFO
} from '../../actions/header';
import { OPEN_HELP } from '../../actions/help';
import {
    CHANGE_COLUMNS_LOG_ORDER,
    CHANGE_COLUMNS_LOG_VISIBILITY
} from '../../actions/log';
import {
    FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT,
    FIRE_SHOW_RECOMMENDATION_CARD_EVENT,
    NO_RECOMMENDATIONS_ERROR_SHOWN,
    OPEN_RECOMMENDATIONS_SCREEN,
    SUBMIT_RECOMMENDATION_CARD
} from '../../actions/recommendations';
import {
    OPEN_RECOMMENDATIONS_GRID_PAGE,
    SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM,
    SUBMIT_RECOMMENDATIONS_GRID_SUMMARY
} from '../../actions/recommendations-grid';
import {
    OPEN_TURBOLANDINGS_CONSTRUCTOR,
    UPDATE_TURBOLANDING
} from '../../actions/turbolandings';
import {
    BASE_USER_SETTINGS_SUBMITTED_METRIKA,
    CREATE_FIRST_CAMPAIGN,
    WELCOME_BANNER_IS_CLICKED,
    WELCOME_BANNER_IS_SHOWN
} from '../../actions/welcome-screen';
import { mapCampaignTypeToCalcType } from '../../mappers/filter/filter';
import { RoutesPath } from '../../routes/index';
import { getCampaignValue } from '../../selectors/campaignsEdit/campaignsEdit';
import {
    selectCalcTypeForMetrika,
    selectGridAdditionalFilterForMetrika,
    selectGridCompactViewForMetrika,
    selectGridFilterExpressionsForMetrika,
    selectGridSourceParamsViewForMetrika,
    selectSelectionForMetrika,
    selectSortParamsForMetrika,
    selectStatPeriodValueForMetrika
} from '../../selectors/metrika';
import { DayBudgetValue } from '../../typings/budget';
import { EditCampaignValueField } from '../../typings/campaignsEdit';
import {
    banners,
    campaigns,
    ColumnsSettings,
    ColumnsSettingsViewDict,
    ColumnViewInfo,
    groups
} from '../../typings/common';
import { RegionCode } from '../../typings/constants';
import { DealsUpdateObject } from '../../typings/deals';
import { Campaign, CampaignType, GroupType } from '../../typings/domain';
import {
    FreelancerFeedbackFormModes,
    FreelancerInfoPanelClickTypes
} from '../../typings/freelancers';
import { GdMenuItem } from '../../typings/graphql-grid';
import { GridAction } from '../../typings/grid';
import { RecommendationType } from '../../typings/recommendations';
import { State } from '../../typings/state';
import { WelcomeBannerType } from '../../typings/welcome';
import { captureException } from '../ErrorsReporting/ErrorsReporting';

import { metrikaApi, MetrikaCounter } from './metrikaApi';

function getYandexUidCookie(): string | undefined {
    return Cookie.get('yandexuid');
}

export function fireBannersEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            editBanners: data
        }
    });
}

export function fireGroupsEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            editGroups: data
        }
    });
}

export function fireCampaignsEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            editCampaigns: data
        }
    });
}

export function fireMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            grid: data
        }
    });
}

export function fireHeaderMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            header: data
        }
    });
}

export function reachGoal(goalName: string, params: {} = {}): void {
    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, goalName, params);
}

export function fireGridActionParams(
    actionName: GridAction,
    selection: object
): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            grid: {
                action: {
                    [actionName]: true,
                    selection
                }
            }
        }
    });
}

function fireSidebarAction(action: ProcessSidebarClick): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            sidebar: {
                click: {
                    [action.id]: true
                }
            }
        }
    });
}

function fireCompactViewAction(isCompactViewEnabled: boolean): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            grid: {
                compactView: isCompactViewEnabled ? 'yes' : 'no'
            }
        }
    });
}

// Если мы репортим в метрику данные сразу при открытии страницы
// то счетчик может не успеть подгрузиться
const metrikaInitTimeout = new Promise(
    (resolve): number => window.setTimeout(resolve, 4000)
);

export const metrikaMiddleware: Middleware<{}, State, Dispatch<Action>> = (
    store: MiddlewareAPI<Dispatch<Action>, State>
): ((next: Dispatch<Action>) => (action: Action) => Action) => (
    next: Dispatch<Action>
): ((action: Action) => Action) => (action: Action): Action => {
    const oldState = store.getState();
    const result = next(action);
    const newState = store.getState();

    metrikaInitTimeout
        .then(() => processAction(oldState as State, newState as State, action))
        .catch(error => {
            captureException(error);
        });

    return result;
};

const columnsSettingsVisibilityDiff = (
    oldSettings: ColumnsSettingsViewDict,
    newSettings: ColumnsSettingsViewDict
): Record<string, boolean> => {
    const visibilityDiff = {};

    forEach(oldSettings, (settingsDict: ColumnsSettings, viewKey: string) => {
        forEach(
            settingsDict,
            (oldColumnSettings: ColumnViewInfo, columnKey: string) => {
                const newColumnSettings = get(
                    newSettings,
                    `${viewKey}${columnKey}`
                );

                if (!newColumnSettings) {
                    return;
                }

                if (
                    Boolean(
                        oldColumnSettings.columnViewInfo[columnKey].hidden
                    ) !==
                    Boolean(newColumnSettings.columnViewInfo[columnKey].hidden)
                ) {
                    visibilityDiff[
                        `${viewKey}-${columnKey}-was-${
                            newColumnSettings.columnViewInfo[columnKey].hidden
                                ? 'hidden'
                                : 'shown'
                        }`
                    ] = true;
                }
            }
        );
    });

    return visibilityDiff;
};

const columnsOrderDiff = (
    oldSettings: ColumnsSettingsViewDict,
    newSettings: ColumnsSettingsViewDict
): string | {} | void => {
    let orderDiff = {};

    if (!newSettings) {
        return;
    }

    forEach(oldSettings, (settingsDict: ColumnsSettings, viewKey: string) => {
        if (
            !isEqual(
                oldSettings[viewKey].columnOrder,
                newSettings[viewKey].columnOrder
            )
        ) {
            orderDiff = `for-${viewKey}-tab-new-order-is:-${
                newSettings[viewKey].columnOrder
            }`;
        }
    });

    return orderDiff;
};

const getChangeDataDealMetrikaCounter = (
    updateDeal: DealsUpdateObject
): void => {
    if (updateDeal.deals.length) {
        metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CHANGE_NAME_DEAL');
    }

    if (updateDeal.add_links.length || updateDeal.remove_links.length) {
        metrikaApi.reachGoal(
            MetrikaCounter.COUNTER_34,
            'BIND_CAMPAIGNS_TO_DEAL'
        );
    }
};

const processAction = (
    oldState: State,
    newState: State,
    action: Action
): void => {
    switch (action.type) {
        case UPDATE_BANNERS_FOR_EDIT: {
            const { banners: bannersToUpd } = action.data;

            const types = new Set();

            const bannersList = values(bannersToUpd);
            bannersList.forEach(banner => {
                // При создании CPM групп, можно менять тип группы
                if (!banner.isNew) {
                    types.add(banner.group.type);
                }
            });

            types.forEach((groupType: GroupType) =>
                fireBannersEditMetrika({
                    groupType
                })
            );

            if (bannersList[0]) {
                const campaignType = bannersList[0].campaign.type;
                fireBannersEditMetrika({
                    calcType: mapCampaignTypeToCalcType(campaignType)
                });
            }

            break;
        }

        case UPDATE_DATA_FOR_EDIT_GROUPS: {
            // Чтобы не портить метрики
            if (action.afterSave) {
                break;
            }

            const { groups: groupsToUpd } = action.data;

            const types = new Set();

            const groupsList = values(groupsToUpd);
            groupsList.forEach(group => {
                // При создании CPC объявлений, можно менять тип баннера
                if (!group.isNew) {
                    types.add(group.value.groupType);
                }
            });

            types.forEach((groupType: GroupType) =>
                fireGroupsEditMetrika({ groupType })
            );

            if (groupsList[0]) {
                const { campaignType } = groupsList[0].value;
                fireGroupsEditMetrika({
                    calcType: mapCampaignTypeToCalcType(campaignType)
                });
            }

            break;
        }

        case CHANGE_BANNERS_TEXT_SUBSTITUTION_FLAG: {
            const campaignValue = getCampaignValue(newState, action.campaignId);

            fireCampaignsEditMetrika({
                changeBannerTextSubstitution:
                    campaignValue[
                        EditCampaignValueField.hasBannersTextSubstitution
                    ]
            });

            break;
        }

        case CHANGE_SHOW_YANDEX_CATALOG_INFO_FLAG: {
            const campaignValue = getCampaignValue(newState, action.campaignId);

            fireCampaignsEditMetrika({
                changeShowPermalinkInfo:
                    campaignValue[EditCampaignValueField.showYandexCatalogInfo]
            });

            break;
        }

        case CHANGE_CONSIDER_COMPETITORS_FLAG: {
            const campaignValue = getCampaignValue(newState, action.campaignId);

            fireCampaignsEditMetrika({
                changeConsiderCompetitors:
                    campaignValue[EditCampaignValueField.considerCompetitors]
            });

            break;
        }

        case CHANGE_COLUMNS_GRID_VISIBILITY: {
            const columnsSettings = columnsSettingsVisibilityDiff(
                oldState.grid.columnsSettings,
                newState.grid.columnsSettings
            );

            fireMetrika({
                columnsSettings
            });

            break;
        }

        case CHANGE_COLUMNS_LOG_VISIBILITY: {
            const columnsSettings = columnsSettingsVisibilityDiff(
                oldState.log.columnsSettings,
                newState.log.columnsSettings
            );

            fireMetrika({
                columnsSettings
            });

            break;
        }

        case CHANGE_COLUMNS_GRID_ORDER: {
            const newGridColumnsOrder = columnsOrderDiff(
                oldState.grid.columnsSettings,
                newState.grid.columnsSettings
            );
            fireMetrika({
                newGridColumnsOrder
            });
            break;
        }

        case CHANGE_COLUMNS_LOG_ORDER: {
            const newLogColumnsOrder = columnsOrderDiff(
                oldState.log.columnsSettings,
                newState.log.columnsSettings
            );
            fireMetrika({
                newLogColumnsOrder
            });
            break;
        }

        case UPDATE_GRID_SELECTION: {
            fireMetrika(selectSelectionForMetrika(newState));

            break;
        }

        case OPEN_PRICES_WIZARD: {
            fireMetrika({
                pricesWizard: {
                    opened: true,
                    phrasesCount: newState.grid.selectionInfo.phrases.length
                }
            });

            break;
        }

        case FETCH_TOOLTIP_DATA: {
            fireMetrika({
                helpTooltip: {
                    opened: true,
                    id: action.id
                }
            });
            break;
        }
        case OPEN_HELP: {
            fireMetrika({
                helpTooltip: {
                    opened: true,
                    id: action.id
                }
            });
            break;
        }

        case UPDATE_CALC_TYPE_FILTER: {
            const oldCalcTypeFilter = selectCalcTypeForMetrika(oldState);
            const newCalcTypeFilter = selectCalcTypeForMetrika(newState);

            if (
                oldCalcTypeFilter &&
                newCalcTypeFilter &&
                oldCalcTypeFilter !== newCalcTypeFilter
            ) {
                fireMetrika({
                    calcTypeFilter: newCalcTypeFilter
                });
            }

            break;
        }

        case RENDER_ON_FINISHED: {
            const { route } = newState.router;

            switch (route) {
                case RoutesPath.shortGrid:
                case RoutesPath.grid: {
                    const calcType = selectCalcTypeForMetrika(newState);
                    const view = selectGridSourceParamsViewForMetrika(newState);

                    fireMetrika({
                        viewWithCalcType: `${view}_${calcType}`
                    });

                    break;
                }

                default:
                    break;
            }

            break;
        }

        case UPDATE_ADDITIONAL_FILTER: {
            const oldAdditionalFilters = selectGridAdditionalFilterForMetrika(
                oldState
            );
            const newAdditionalFilters = selectGridAdditionalFilterForMetrika(
                newState
            );

            if (
                oldAdditionalFilters &&
                newAdditionalFilters &&
                oldAdditionalFilters !== newAdditionalFilters
            ) {
                fireMetrika({
                    additionalFilters: newAdditionalFilters
                });
            }

            break;
        }

        case LOCATION_CHANGED: {
            const { route } = newState.router;

            switch (route) {
                case RoutesPath.shortGrid:
                case RoutesPath.grid: {
                    const oldView = selectGridSourceParamsViewForMetrika(
                        oldState
                    );
                    const newView = selectGridSourceParamsViewForMetrika(
                        newState
                    );

                    if (oldView !== newView) {
                        fireMetrika({
                            view: newView
                        });
                    }

                    const oldSortParams = selectSortParamsForMetrika(oldState);
                    const newSortParams = selectSortParamsForMetrika(newState);

                    if (
                        oldSortParams &&
                        newSortParams &&
                        oldSortParams !== newSortParams
                    ) {
                        fireMetrika({
                            sortParams: newSortParams
                        });
                    }

                    const oldFilters = selectGridFilterExpressionsForMetrika(
                        oldState
                    );
                    const newFilters = selectGridFilterExpressionsForMetrika(
                        newState
                    );

                    if (!isEqual(oldFilters, newFilters)) {
                        fireMetrika(newFilters);
                    }

                    const oldStatPeriodValue = selectStatPeriodValueForMetrika(
                        oldState
                    );
                    const newStatPeriodValue = selectStatPeriodValueForMetrika(
                        newState
                    );

                    if (
                        oldStatPeriodValue &&
                        oldStatPeriodValue !== newStatPeriodValue
                    ) {
                        fireMetrika({
                            statPeriodValue: newStatPeriodValue
                        });
                    }

                    break;
                }

                default:
                    break;
            }

            break;
        }

        case OPEN_EDIT_CAMPAIGN_POPUP: {
            fireMetrika({
                openCampaignEditPopup: true
            });

            break;
        }

        case OPEN_EDIT_GROUPS_POPUP: {
            fireMetrika({
                openGroupEditPopup: true
            });

            break;
        }

        case SWITCH_TO_OLD_INTERFACE: {
            reachGoal('NEW_INTERFACE_BACK_TO_OLD');

            break;
        }

        case UPDATE_HEADER_INFO: {
            if (
                (newState.header.allowedMenuItems || []).includes(
                    GdMenuItem.RECOMMENDATIONS
                )
            ) {
                reachGoal('recommendations_ShowLink');
            }
            break;
        }
        case OPEN_GRID_SCREEN_RECOMMENDATIONS_POPUP: {
            fireMetrika({
                recommendationsPopup: {
                    opened: {
                        view: action.view
                    }
                }
            });

            const goal = {
                [campaigns]: 'recommendations_Popup_opened_campaigns',
                [groups]: 'recommendations_Popup_opened_groups',
                [banners]: 'recommendations_Popup_opened_banners'
            }[action.view];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        case FIRE_SHOW_GRID_SCREEN_RECOMMENDATION_EVENT: {
            fireMetrika({
                recommendationsPopup: {
                    showRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            break;
        }

        // нажатие кнопки Отправить гарантийное письмо на гриде баннеров
        case FIRE_GRID_SCREEN_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT: {
            fireMetrika({
                recommendationsPopup: {
                    sendLicenceButtonClick: true
                }
            });

            reachGoal('recommendations_Popup_sendLicenceButtonClick');

            break;
        }

        // нажатие кнопки применить рекомендации на дашборде
        case SUBMIT_GRID_SCREEN_RECOMMENDATION_ITEM: {
            fireMetrika({
                recommendationsPopup: {
                    submittedRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]:
                    'recommendations_Page_SubmittedRecommendation_DailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_Page_SubmittedRecommendation_RemovePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_Page_SubmittedRecommendation_SwitchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // открытие дашборда рекомендаций
        case OPEN_RECOMMENDATIONS_SCREEN: {
            fireMetrika({
                recommendationsPage: {
                    opened: true
                }
            });

            reachGoal('recommendations_Page_opened');

            break;
        }

        case NO_RECOMMENDATIONS_ERROR_SHOWN: {
            fireMetrika({
                recommendationsPage: {
                    empty: true
                }
            });

            reachGoal('recommendations_Page_empty');
            break;
        }

        // показ типа рекомендации на странице списка рекомендаций
        case FIRE_SHOW_RECOMMENDATION_CARD_EVENT: {
            fireMetrika({
                recommendationsPage: {
                    showRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]:
                    'recommendations_Page_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_Page_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_Page_switchOnAutotargeting',
                [RecommendationType.changeAdGroupForModeration]:
                    'recommendations_Page_moderation',
                [RecommendationType.changeBannerForModeration]:
                    'recommendations_Page_moderation',
                [RecommendationType.sendLicenses]:
                    'recommendations_Page_guarantee',
                [RecommendationType.changeAdGroupWithLowStat]:
                    'recommendations_Page_rarelyServed'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки применить на гриде кампаний, баннеров, фраз
        case SUBMIT_RECOMMENDATION_CARD: {
            fireMetrika({
                recommendationsPage: {
                    submittedRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]:
                    'recommendations_Popup_submittedRecommendation_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_Popup_submittedRecommendation_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_Popup_submittedRecommendation_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки Отправить гарантийное письмо на дашборде
        case FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT: {
            fireMetrika({
                recommendationsPage: {
                    sendLicenceButtonClick: true
                }
            });

            reachGoal('recommendationsPageSendLicenceButtonClick');

            break;
        }

        // переход на страничку с детализацией рекомендации
        case OPEN_RECOMMENDATIONS_GRID_PAGE: {
            fireMetrika({
                recommendationsGridPage: {
                    opened: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]:
                    'recommendations_GridPage_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_GridPage_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_GridPage_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки применить cтраничке с детализацией рекомендации суммарно по таблице
        case SUBMIT_RECOMMENDATIONS_GRID_SUMMARY: {
            fireMetrika({
                recommendationsGridPage: {
                    submittedSummary: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]:
                    'recommendations_GridPage_submittedSummary_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_GridPage_submittedSummary_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_GridPage_submittedSummary_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки применить cтраничке с детализацией рекомендации на элемент таблицы
        case SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM: {
            fireMetrika({
                recommendationsGridPage: {
                    submittedGridItem: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]:
                    'recommendations_GridPage_submittedGridItem_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_GridPage_submittedGridItem_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_GridPage_submittedGridItem_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // welcome page
        case BASE_USER_SETTINGS_SUBMITTED_METRIKA: {
            const { baseSettings } = oldState.welcome;

            metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'PAGE_EMAIL', {
                yandexuid: getYandexUidCookie()
            });
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_191494, 'NEWLOGIN');

            if (baseSettings.email) {
                metrikaApi.reachGoal(
                    MetrikaCounter.COUNTER_191494,
                    'SET_EMAIL'
                );
            }

            switch (baseSettings.country) {
                case RegionCode.RUSSIA:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CHOOSE_RUSSIA'
                    );
                    break;
                case RegionCode.BELORUSSIA:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CHOOSE_BEL'
                    );
                    break;
                case RegionCode.KAZAKHSTAN:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CHOOSE_KAZ'
                    );
                    break;
                default:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CHOOSE_DRUGIE'
                    );
                    break;
            }

            break;
        }

        case CREATE_FIRST_CAMPAIGN: {
            if (action.campType === CampaignType.TEXT) {
                metrikaApi.reachGoal(
                    MetrikaCounter.COUNTER_34,
                    'FIRST_CAMP_TEXT'
                );
            } else {
                metrikaApi.reachGoal(
                    MetrikaCounter.COUNTER_34,
                    'FIRST_CAMP_NO_TEXT'
                );
            }
            break;
        }

        case WELCOME_BANNER_IS_SHOWN: {
            switch (action.bannerType) {
                case WelcomeBannerType.YANDEX:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'SHOW_YANDEX_BANNER'
                    );
                    break;
                case WelcomeBannerType.AGENCY:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'SHOW_AGENCY_BANNER'
                    );
                    break;
                case WelcomeBannerType.FREELANCER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'SHOW_FREELANCER_BANNER'
                    );
                    break;
                default:
                    break;
            }
            break;
        }

        case WELCOME_BANNER_IS_CLICKED: {
            switch (action.bannerType) {
                case WelcomeBannerType.YANDEX:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CLICK_YANDEX_BANNER'
                    );
                    break;
                case WelcomeBannerType.AGENCY:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CLICK_AGENCY_BANNER'
                    );
                    break;
                case WelcomeBannerType.FREELANCER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'CLICK_FREELANCER_BANNER'
                    );
                    break;
                default:
                    break;
            }
            break;
        }

        case SHOW_FREELANCER_CONTACTS:
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_49312303, 'KARTA', {
                URL: document.location.href
            });
            break;

        case ACKNOWLEDGE_USER_STAYED_ON_CARD:
            const { authorizationData } = oldState.commonData;
            const freelancerLogin =
                oldState.router.params &&
                oldState.router.params.freelancerLogin;

            if (authorizationData) {
                if (
                    authorizationData.isFreelancer &&
                    freelancerLogin !== authorizationData.login
                ) {
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'ACKNOWLEDGE_FREELANCER_STAYED_ON_CARD',
                        {
                            URL_30_sec: document.location.href
                        }
                    );
                }

                if (!authorizationData.isFreelancer) {
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'ACKNOWLEDGE_CUSTOMER_STAYED_ON_CARD',
                        {
                            URL_30_sec: document.location.href
                        }
                    );
                }
            }

            break;

        case FREELANCER_INFO_PANEL_CLICKED:
            switch (action.clickType) {
                case FreelancerInfoPanelClickTypes.FREELANCER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_FREELANCER',
                        { URL_click_on_freelancer: document.location.href }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.MY_PROFILE:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_MY_PROFILE',
                        { URL_click_on_my_profile: document.location.href }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.MY_CUSTOMERS:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_MY_CUSTOMERS',
                        { URL_click_on_my_customers: document.location.href }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.ALL_SPECIALISTS_BY_FREELANCER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_ALL_SPECIALISTS_BY_FREELANCER',
                        {
                            URL_click_on_all_specialists_by_freelancer:
                                document.location.href
                        }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.ALL_SPECIALISTS_BY_CUSTOMER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_ALL_SPECIALISTS_BY_CUSTOMER',
                        {
                            URL_click_on_all_specialists_by_customer:
                                document.location.href
                        }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.BECOME_SPECIALIST:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_BECOME_SPECIALIST',
                        {
                            URL_click_on_become_specialist:
                                document.location.href
                        }
                    );
                    break;
                default:
                    break;
            }
            break;

        case ADD_FREELANCER_FEEDBACK_START:
            metrikaApi.reachGoal(
                MetrikaCounter.COUNTER_34,
                'FREELANCER_ADD_FEEDBACK',
                { URL_dobavit_otzyv: document.location.href }
            );
            break;

        case REQUEST_COOP_BY_CUSTOMER_START:
            reachGoal('FREELANCER_GIVE_ACCESS', {
                URL_dostyp: document.location.href,
                yandexuid: getYandexUidCookie()
            });
            break;

        case OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT:
            reachGoal('FREELANCER_START_COOP', {
                URL_sotrydnichat: document.location.href,
                yandexuid: getYandexUidCookie()
            });
            break;

        case OPEN_FREELANCER_FEEDBACK_FORM:
            if (
                action.mode === FreelancerFeedbackFormModes.ADD_NEW_FEEDBACK ||
                action.mode === FreelancerFeedbackFormModes.EDIT_FEEDBACK
            ) {
                metrikaApi.reachGoal(
                    MetrikaCounter.COUNTER_34,
                    'FREELANCER_FEEDBACK_POPUP_OPEN',
                    { URL_ostavit_otzyv: document.location.href }
                );
            }
            break;

        case OPEN_DEAL_INSPECTOR:
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'DEAL_CONDITIONS');
            break;

        case ACCEPT_REJECT_DEALS:
            if (action.updateObject) {
                getChangeDataDealMetrikaCounter(action.updateObject);
            }

            action.isAccept
                ? metrikaApi.reachGoal(
                      MetrikaCounter.COUNTER_34,
                      'APPROVE_DEAL'
                  )
                : metrikaApi.reachGoal(
                      MetrikaCounter.COUNTER_34,
                      'REJECT_DEAL'
                  );
            break;

        case UPDATE_DEALS:
            getChangeDataDealMetrikaCounter(action.updateObject);
            break;
        case OPEN_MASS_ACTIONS_BANNERS_PRICE:
            fireBannersEditMetrika({
                bannersMassActions: {
                    bannerPrice: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE:
            fireBannersEditMetrika({
                bannersMassActions: {
                    bannerPrice: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkReplacement: {
                        open: true
                    }
                }
            });

            break;
        case SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageCreativeReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageCreativeReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpmImageCreativeBulkReplacementEditorVisible: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpmImageCreativeBulkReplacementEditorVisible: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_OPEN_MASS_ACTIONS_PIXEL:
            fireBannersEditMetrika({
                bannersMassActions: {
                    pixelEditorVisible: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    pixelEditorVisible: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    countersEditorVisible: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_OPEN_MASS_ACTIONS_COUNTERS:
            fireBannersEditMetrika({
                bannersMassActions: {
                    countersEditorVisible: {
                        open: true
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpcVideoReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpcVideoReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkPathReplacement: {
                        open: true
                    }
                }
            });

            break;
        case SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkPathReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkDisplayedReplacement: {
                        open: true
                    }
                }
            });

            break;
        case OPEN_TURBOLANDINGS_CONSTRUCTOR:
            fireBannersEditMetrika({
                turbolandingConstructor: {
                    open: true
                }
            });

            break;
        case UPDATE_TURBOLANDING:
            fireBannersEditMetrika({
                turbolandingConstructor: {
                    updated: true
                }
            });

            break;
        case ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkDisplayedReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    videoReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    videoReplacementAccept: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    turbolandingReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    turbolandingReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    trackingParametersReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    trackingParametersReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_OPEN_MASS_ACTIONS_CALLOUTS:
            fireBannersEditMetrika({
                bannersMassActions: {
                    callouts: {
                        open: true
                    }
                }
            });

            break;
        case ACCEPT_MASS_ACTIONS_CALLOUTS:
            fireBannersEditMetrika({
                bannersMassActions: {
                    callouts: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });
            break;
        case ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    siteLinks: {
                        open: true
                    }
                }
            });
            break;
        case ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    siteLinks: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_BULK_IMAGE_REPLACEMENT:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    textReplacement: {
                        open: true
                    }
                }
            });

            break;
        case SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    textReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT:
            reachGoal('ACKNOWLEDGE_USER_FROM_CARD', {
                yandexuid: getYandexUidCookie()
            });

            break;
        case FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE:
            reachGoal('LOGGEDIN_USER_FROM_CARD', {
                yandexuid: getYandexUidCookie()
            });

            break;

        case FIRE_COMMON_WALLET_CLICK:
            reachGoal('COMMON_WALLET_CLICK', {
                URL_common_wallet_click: document.location.href
            });
            break;

        case PROCESS_SIDEBAR_CLICK: {
            fireSidebarAction(action);
            break;
        }

        case TOGGLE_COMPACT_VIEW: {
            const isCompactViewEnabled = selectGridCompactViewForMetrika(
                newState
            );
            fireCompactViewAction(isCompactViewEnabled);
            break;
        }

        case UPDATE_CAMPAIGN_DAY_BUDGET_INFO: {
            const targetCampaign = oldState.grid.gridData.data.find(
                (campaign: Campaign) => {
                    return campaign.id === action.campaignId;
                }
            ) as Campaign | undefined;

            try {
                if (targetCampaign !== undefined) {
                    const oldBudget = targetCampaign.budget
                        .value as DayBudgetValue;
                    const newBudget = action.value;
                    const isNewBudgetActive =
                        newBudget !== undefined && newBudget.isActive;

                    if (oldBudget.isActive && !isNewBudgetActive) {
                        reachGoal('DAILY_BUDGET_LIMIT_CAMPAIGN_OFF');
                    }

                    if (newBudget !== undefined) {
                        if (
                            oldBudget.isActive &&
                            isNewBudgetActive &&
                            oldBudget.sum < newBudget.sum
                        ) {
                            reachGoal('DAILY_BUDGET_LIMIT_CAMPAIGN_INCREASE');
                        } else if (
                            oldBudget.isActive &&
                            isNewBudgetActive &&
                            oldBudget.sum > newBudget.sum
                        ) {
                            reachGoal('DAILY_BUDGET_LIMIT_CAMPAIGN_DECREASE');
                        }
                    }
                }
            } catch (e) {
                // для редкого случая когда в gridData уже не кампании, но по id-ку почему-то что-то нашлось
                captureException(e);
            }

            break;
        }

        default: {
            return;
        }
    }
};
